import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { MetricService } from '../metric.service';
import { MetricBaseAbstract } from '../metric-base.abstract';
import { combineLatestWith } from 'rxjs';
import { CounterConfig } from '../interfaces/counter-config.interface';
import { UtmParams } from './utm-params.interface';

@UntilDestroy()
@Component({
    selector: 'app-ya-metric',
    templateUrl: './ya-metric.component.html',
    standalone: true
})
export class YaMetricComponent extends MetricBaseAbstract {
  constructor(
    private metrica: MetricService,
    private router: Router
  ) {super()}

  private yaCounters: any[] = [];

  protected override onRunMetric(codes: string[]): void {
    this.runYAM(codes);

    this.router.events.pipe(
      combineLatestWith(this.metrica.utmParams$),
      untilDestroyed(this)
    ).subscribe(([event, utmParams]) => {
      if (event instanceof NavigationEnd) {
        this.hitYandex(window.location.href, utmParams);
      }
    });

    this.metrica.metricEventGoal$.subscribe(goal => {
      this.fireYandexGoal(goal)
    })
  }

  private runYAM(codes: string[]): void {
    this.insertYAMetrika().then(Ya => {
      codes.forEach(code => {
        if (code) {
          const config: CounterConfig = {id: code, ecommerce: 'iikoLayer', webvisor: true, defer: true};
          const counter = new Ya.Metrika2(config);
          this.yaCounters.push(counter);
          (window as any)['yaCounter_' + code] = counter;
        }
      });
      this.hitYandex(window.location.href, this.metrica.utmParams);
    });
  }

  private insertYAMetrika(): Promise<any> {
    return this.loadScript('https://mc.yandex.ru/metrika/tag.js').then(() => {
      return (window as any).Ya;
    });
  }

  hitYandex(url: string, utmParams: UtmParams | null): void {
    if(utmParams){
      const queryParams = new URLSearchParams(utmParams as Record<string, string>);
      url += '?' +  queryParams;
    }

    this.yaCounters.forEach(counter => {
      counter.hit(url)
    })
  }

  fireYandexGoal(goal: string): void {
    const ecommCounter = this.yaCounters[this.yaCounters.length - 1];
    if(!ecommCounter) {return}
    ecommCounter.reachGoal(goal);
  }
}
